import _                                                                        from 'underscore';
import React, { FC }                                                            from 'react';
import { Label, LabelProps }                                                    from 'semantic-ui-react';
import { CONSTANTS }                                                            from '../../../constants';
import { EnumDescriptorType, ActivityCriticalityTypeSet, ACTIVITY_CRITICALITY } from '../../../constants/ProductEnums';
import { SemanticUIColor }                                                      from '../../../types/componentPropTypes';
import { SystemEvent }                                                          from '../../../types/events';
import { useProjectTermDictionary }                                             from '../../../hooks/useTermDictionary';

interface ActvityCriticalityLabelProps extends LabelProps {
	value?: ACTIVITY_CRITICALITY,
	color?: SemanticUIColor
	
	onClick?( e: SystemEvent ): void
}

const defaultProps: ActvityCriticalityLabelProps = {
	value:   null,
	color:   null,
	onClick: null,
}

const ActivityCriticalityLabel: FC<ActvityCriticalityLabelProps> = ( props ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	let types: ActivityCriticalityTypeSet    = CONSTANTS.PRODUCT.ACTIVITY_CRITICALITY_INFO,
	    type: EnumDescriptorType | undefined = _.findWhere( types, { VALUE: props.value } as never ),
	    label                                = props.value as string,
	    color                                = props.color;
	
	let { CRITICAL, PRIORITY, MODERATE, MINOR } = types;
	
	if( type ){
		
		if( !props.color ){
			switch( props.value ){
				
				case CRITICAL.VALUE :
					color = CRITICAL.COLOR as SemanticUIColor;
					break;
				case PRIORITY.VALUE :
					color = PRIORITY.COLOR as SemanticUIColor;
					break;
				case MODERATE.VALUE :
					color = MODERATE.COLOR as SemanticUIColor;
					break;
				case MINOR.VALUE :
					color = MINOR.COLOR as SemanticUIColor;
					break;
			}
		}
		
		label = getTerm( type.LABEL );
	}
	
	return (
		
		<Label circular
		       { ...props }
		       color={ color }
		       content={ label }
		       onClick={ props.onClick }/>
	);
};

ActivityCriticalityLabel.defaultProps = defaultProps;

export { ActivityCriticalityLabel }
